export const SPARTAN_HOME_EVENT_NAME = 'lcv-home-click';
